<p-dialog
  [header]="header"
  [modal]="true"
  [style]="{ width: width }"
  [(visible)]="dialogVisible"
  (onHide)="hiddenEvent()"
  [appendTo]="appendTo"
>
  <ng-container *ngIf="dialogVisible">
    <ng-container *ngTemplateOutlet="contentTemplate"></ng-container>
    <div class="tw-flex tw-justify-end tw-gap-2">
      <p-button
        severity="secondary"
        [label]="secondaryBtnText"
        (onClick)="secondaryBtnEvent()"
      />
      <p-button
        *ngIf="!primaryBtnHidden"
        [severity]="primaryBtnSeverity"
        [label]="primaryBtnText"
        [disabled]="primaryBtnDisabled"
        (onClick)="primaryBtnEvent()"
      />
    </div>
  </ng-container>
</p-dialog>
